import type { FaireProductEntity } from "../../entity_types/product";

export const p_cqc8cb6c2s: FaireProductEntity = {
  token: "p_cqc8cb6c2s",
  type: "product",
  name: "Bowlcut Chili Crisp",
  brandToken: "b_62pftzpc9j",
  brandName: "Bowlcut",
  imageUrl:
    "https://cdn.faire.com/fastly/0f9826fa1df24d741790c0a8b634621514a1bc50ea819c2b829de6ac68ffe55d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b033a2f068db82832414e2c8c6941d2b36cf60eaf43ce0d97164c693cc836be.png",
    "https://cdn.faire.com/fastly/0e1937571596144b5ca755db7d33bb923d527cc9e4d6099822e8c8c32257607f.jpeg",
    "https://cdn.faire.com/fastly/6e92ffe22ddfc03e08db6eae90ab2b1626b08a0e5b19e1d8a5fcff64aac5f1b2.jpeg",
    "https://cdn.faire.com/fastly/ceda7417998814d934f137e336f261c30b528b20fc92ba6e957019838619ddab.png",
    "https://cdn.faire.com/fastly/533e567a1a37a5c1941fce0f78f66c076e580070c6e63a816753d4d64fe33a79.jpeg",
    "https://cdn.faire.com/fastly/22991352b99ea4cb774a61b90f1b8337dc2abee6ad9400e48e1d083eaab1b8a8.jpeg",
    "https://cdn.faire.com/fastly/7dac1061505ce7f7d58c04d9eed19a94804a52a70acfb323afb99982557f8884.jpeg",
    "https://cdn.faire.com/fastly/4b3d5a0fda346326194d68ae9d72269d968177ac135ed99f0a742b71ac11c15f.webp",
    "https://cdn.faire.com/fastly/84b462f197a89217854780cddb7f9649fd66ba843d188da9fdba8c48b0ee66ed.webp",
    "https://cdn.faire.com/fastly/ae3bec3e118b92a0025240de22c98cd3cdd89d643a04de445cb0a58e1a577502.webp",
  ],
  priceDollars: 8.75,
  description:
    "A little Chili Crisp goes a long way, but that doesn’t mean you should hold back. Those who like their oil with a little kick, this one’s for you. Rich umami flavors are brightened by a touch of sweetness, making our chili crisp the ideal pairing to your favorite foods. \n",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T06:30:57.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
